import script from "./message.vue?vue&type=script&lang=ts&setup=true"
export * from "./message.vue?vue&type=script&lang=ts&setup=true"

import "./message.vue?vue&type=style&index=0&id=0897af5e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0897af5e"]])

export default __exports__